import wallet from "assets/images/wallet.svg";
import tick from "assets/images/tick.svg";
import cross from "assets/images/cross.svg";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CAR from "assets/images/CAR.svg";

export const subVendorVechileMatrix = (vehicleMatrixData) => [
  {
    id: 1,
    icon: tick,
    amt: vehicleMatrixData?.totalRides,
    name: "Total Rides",
  },
  {
    id: 2,
    icon: tick,
    amt: vehicleMatrixData?.completedRides,
    name: "Completed Ride",
  },
];

export const editSubVehicleDialogData = (details) => [
  {
    placeholder: "carModel",
    required: true,
    type: "text",
    name: "carModel",
    label: "Car Model",
    star: "*",
    countrycode: false,
  },
  {
    placeholder: "regNumber",
    required: true,
    type: "text",
    name: "regNumber",
    label: "Reg Number",
    star: "*",
    countrycode: false,
  },
  {
    placeholder: "color",
    required: true,
    type: "text",
    name: "color",
    label: "Color",
    star: "*",
    countrycode: false,
  },
  {
    placeholder: "fuelType",
    required: false,
    type: "text",
    name: "fuelType",
    label: "Fuel Type",
    star: "*",
    countrycode: false,
  },
  {
    placeholder: "seating",
    required: true,
    type: "text",
    name: "seating",
    label: "Seating",
    star: "*",
    countrycode: false,
  },
  {
    placeholder: "rcOwner",
    required: "true",
    type: "text",
    name: "rcOwner",
    label: "RC Owner",
    star: "*",
  },
  {
    placeholder: "policyCompany",
    required: "true",
    type: "text",
    name: "policyCompany",
    label: "Policy Company",
    star: "*",
  },
  {
    placeholder: "policyNumber",
    required: "true",
    type: "text",
    name: "policyNumber",
    label: "Policy Number",
    star: "*",
  },
  {
    placeholder: "chasisNum",
    required: "true",
    type: "text",
    name: "chasisNum",
    label: "Chasis Number",
    star: "*",
  },
  {
    placeholder: "engineNum",
    required: "true",
    type: "text",
    name: "engineNum",
    label: "Engine Number",
    star: "*",
  },
];

export const vehicleTableData = {
  header: [
    {
      label: "ID",
      key: "id",
    },
    {
      label: "Vehicle Name",
      key: "vehicleName",
    },
    {
      label: "Type",
      key: "type",
    },
    {
      label: "Rc Owner",
      key: "rcOwner",
    },
    {
      label: "Ride",
      key: "ride",
    },
    {
      label: "Location",
      key: "location",
    },
    {
      label: "Rating",
      key: "rating",
    },
    {
      label: "",
      key: "icon",
    },
  ],
  body: [
    {
      id: "1",
      vehicleName: "Maruti 800",
      vehicleImage: "image",
      vehicleNumber: "KA 05 MB 0001",
      type: "Mini",
      rcOwner: "Gokul",
      ride: "200",
      location: "Bangalore",
      rating: "3",
      icon: <MoreVertIcon />,
    },
    {
      id: "1",
      vehicleName: "Maruti 800",
      vehicleImage: "image",
      vehicleNumber: "KA 05 MB 0001",
      type: "Mini",
      rcOwner: "Gokul",
      ride: "200",
      location: "Bangalore",
      rating: "3",
      icon: <MoreVertIcon />,
    },
    {
      id: "1",
      vehicleName: "Maruti 800",
      vehicleImage: "image",
      vehicleNumber: "KA 05 MB 0001",
      type: "Mini",
      rcOwner: "Gokul",
      ride: "200",
      location: "Bangalore",
      rating: "3",
      icon: <MoreVertIcon />,
    },
    {
      id: "1",
      vehicleName: "Maruti 800",
      vehicleImage: "image",
      vehicleNumber: "KA 05 MB 0001",
      type: "Mini",
      rcOwner: "Gokul",
      ride: "200",
      location: "Bangalore",
      rating: "3",
      icon: <MoreVertIcon />,
    },
    {
      id: "1",
      vehicleName: "Maruti 800",
      vehicleImage: "image",
      vehicleNumber: "KA 05 MB 0001",
      type: "Mini",
      rcOwner: "Gokul",
      ride: "200",
      location: "Bangalore",
      rating: "3",
      icon: <MoreVertIcon />,
    },
    {
      id: "1",
      vehicleName: "Maruti 800",
      vehicleImage: "image",
      vehicleNumber: "KA 05 MB 0001",
      type: "Mini",
      rcOwner: "Gokul",
      ride: "200",
      location: "Bangalore",
      rating: "3",
      icon: <MoreVertIcon />,
    },
  ],
};

export const vehicleInfo = (vehicleInfotable) => [
  {
    title: "Model Name :",
    body: vehicleInfotable?.carModel,
  },
  {
    title: "Vehicle no : ",
    body: vehicleInfotable?.regNumber,
  },
  {
    title: "Vehicle Color : ",
    body: vehicleInfotable?.colour,
  },
  {
    title: "Fuel type : ",
    body: vehicleInfotable?.fuelType,
  },
  {
    title: "Vehicle Capacity : ",
    body: vehicleInfotable?.seating,
  },
  {
    title: "Category : ",
    body: vehicleInfotable?.carType,
  },
  {
    title: "Chasis No : ",
    body: vehicleInfotable?.chasisNum,
  },
  {
    title: "Engine no : ",
    body: vehicleInfotable?.engineNum,
  },
];

export const amenitiesVehicle = (vehicleInfoaminities) => [
  {
    id: 1,
    image: CAR,
    title: "Stepney",
    body: vehicleInfoaminities?.stepney,
  },
  {
    id: 2,
    image: CAR,
    title: "Fire Extinguisher",
    body: vehicleInfoaminities?.fireExtinguisher,
  },
  {
    id: 3,
    image: CAR,
    title: "First-aid Kit",
    body: vehicleInfoaminities?.firstAid,
  },
  {
    id: 4,
    image: CAR,
    title: "Last Vehicle inspection",
    body: vehicleInfoaminities?.lastInspection,
  },
  {
    id: 5,
    image: CAR,
    title: "Last Service Date",
    body: vehicleInfoaminities?.lastService,
  },
  {
    id: 6,
    image: CAR,
    title: "Last Service Meter Reading",
    body: vehicleInfoaminities?.lastMeterReading,
  },
];

//Vehicle Dialog Data
export const vehicleDialogData = (optionData) => [
  {
    placeholder: "Image",
    required: true,
    type: "file",
    name: "Avtar",
    star: "*",
    countrycode: false,
  },
  {
    placeholder: "Model Name",
    required: true,
    type: "text",
    name: "carModel",
    label: "Model Name",
    star: "*",
    countrycode: false,
  },
  {
    placeholder: "Vehicle Number",
    required: true,
    type: "text",
    name: "regNumber",
    label: "Vehicle Number",
    star: "*",
    countrycode: false,
  },
  {
    placeholder: "Vehicle Color",
    required: true,
    type: "text",
    name: "colour",
    label: "Vehicle Color",
    star: "*",
    countrycode: false,
  },
  {
    placeholder: "Fuel Type",
    required: true,
    type: "select",
    name: "fuelType",
    label: "Fuel Type",
    star: "*",
    countrycode: false,
    options: [
      {
        value: "Petrol",
        label: "Petrol",
      },
      {
        value: "Diesel",
        label: "Diesel",
      },
      {
        value: "CNG",
        label: "CNG",
      },
    ],
  },
  {
    placeholder: "Category",
    required: true,
    type: "select",
    name: "carTypeId",
    label: "Category",
    star: "*",
    countrycode: false,
    options: optionData,
  },
  {
    placeholder: "Seating Capacity",
    required: true,
    type: "text",
    name: "seating",
    label: "Seating Capacity(including driver)",
    star: "*",
    countrycode: false,
  },
  {
    required: true,
    type: "text",
    name: "stepney",
    label: "Do you have Stepney ?",
    star: "*",
    values: [
      {
        value: "true",
        label: "Yes",
      },
      {
        value: "false",
        label: "No",
      },
    ],
  },
  {
    required: true,
    type: "text",
    name: "fireExtinguisher",
    label: "Do you have Fire Extinguisher ?",
    star: "*",
    values: [
      {
        value: "true",
        label: "Yes",
      },
      {
        value: "false",
        label: "No",
      },
    ],
  },
  {
    required: true,
    type: "text",
    name: "firstAid",
    label: "Do you have First-aid Kit ?",
    star: "*",
    values: [
      {
        value: "true",
        label: "Yes",
      },
      {
        value: "false",
        label: "No",
      },
    ],
  },
  {
    datePicker: true,
    required: false,
    placeholder: "last Vehicle Inspection Date",
    type: "date",
    name: "lastInspection",
    label: "Last Vehicle Inspection Date",
    star: "*",
  },
  {
    datePicker: true,
    required: false,
    placeholder: "last Service Date",
    type: "date",
    name: "lastService",
    label: "Last Service Date",
    star: "*",
  },
  {
    placeholder: "Last Meter Reading",
    required: false,
    type: "number",
    name: "lastMeterReading",
    label: "Last Meter Reading",
    star: "*",
  },
  {
    placeholder: "RC Owner",
    required: true,
    type: "text",
    name: "rcOwner",
    label: "RC Owner",
    star: "*",
  },
  {
    placeholder: "Chasis Number",
    required: true,
    type: "text",
    name: "chasisNum",
    label: "Chasis Number",
    star: "*",
  },
  {
    placeholder: "Engine Number",
    required: true,
    type: "text",
    name: "engineNum",
    label: "Engine Number",
    star: "*",
  },
];

export const filterdata = [
  {
    id: 1,
    primaryText: "Status",
    subItems: [
      { value: "Active",list: 'Active', key: "Status" },
      { value: "InActive",list: 'InActive', key: "Status" },
      { value: "Blocked",list: 'Blocked', key: "Status" },
      { value: "Pending",list: 'Pending', key: "Status" },
    ],
  },
];
